import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
import config from '@/../public/config.json'

const HTTP = axiosConfig.HTTP

// state
const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: ''
}

// getters
const getters = {
  getListNavProfileData: state => state.code
}

// actions
const actions = {
  async listNavProfil ({ commit }, data) {
    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: 0,
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          }
        }
      })
      commit('LISTNAVPROFIL_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.listNavProfil, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            commit('LISTNAVPROFIL_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LISTNAVPROFIL_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LISTNAVPROFIL_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LISTNAVPROFIL_REQUEST_SUCCEED' (state, payload) {
    state.code = payload
    state.error = false
    state.errorDescription = ''
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
